// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b71a5013","793":"5d9ffd26","826":"23cfea69"}[chunkId] + ".chunk.js";
};